export default "__VITE_ASSET__ELGyKRXR__"